var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import DeviceModel from '../../models/DeviceModel';
import PersistentCollection from "../PersistentCollection";
import { compareNumbers, compareStrings } from "../../utils/compareUtils";
import FilterRuleContainsString from "../filters/FilterRuleContainsString";
/**
 *
 */
var DeviceCollection = /** @class */ (function (_super) {
    __extends(DeviceCollection, _super);
    /**
     *
     */
    function DeviceCollection() {
        var _this = _super.call(this, DeviceModel) || this;
        _this.searchStringFilter = new FilterRuleContainsString('filterString');
        _this.filter.addRule(_this.searchStringFilter);
        return _this;
    }
    /**
     *
     * @param id
     * @return {*}
     */
    DeviceCollection.prototype.findById = function (id) {
        return this.list.find(function (model) {
            return model.link_device_id === id;
        });
    };
    /**
     *
     * @param items
     * @return {*}
     * @private
     */
    DeviceCollection.prototype.applySort = function (items) {
        var sort = this.sort;
        if (!sort)
            return items;
        var result = items.concat([]);
        result.sort(function (a, b) {
            var _a, _b;
            switch (sort.fieldName) {
                case 'battery':
                    return compareNumbers((_a = a.batteryRemainingPctValue) !== null && _a !== void 0 ? _a : -1, (_b = b.batteryRemainingPctValue) !== null && _b !== void 0 ? _b : -1);
                case 'location':
                    return compareStrings(a.place, b.place);
                default:
                    return compareStrings(a[sort.fieldName], b[sort.fieldName]);
            }
        });
        if (sort.direction < 0) {
            result.reverse();
        }
        return result;
    };
    return DeviceCollection;
}(PersistentCollection));
export default DeviceCollection;
